import React, { memo, ReactNode, useEffect, useState } from 'react';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';
import { HomeScreenContainer } from './home-screen.styles'; // Ensure this path is correct
import useHomeScreenHook from './home-screen.hook';
import themes from './themes';
import MainHome from '../../components/home-menu-components/mainHome';
import MainHome2 from '../../components/home-menu-components/settingsPage';

export interface HomeScreenProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

type Props = HomeScreenProps & ThemeOverride;

function HomeScreen(props: Props) {
  const { children, className, style, size, themeMode } = props;
  const { t } = useHomeScreenHook(props);

  const [displayItems, setDisplayItems] = useState<ReactNode>(<></>);
  const boxSize = { height: '15vh', width: '9vw' };

  return (
    <ThemeProvider themes={themes} selectedMode={themeMode}>
        <HomeScreenContainer className={className} style={style}>
          {<MainHome  boxSize={boxSize} />}
          {children}
      </HomeScreenContainer>
    </ThemeProvider>

  );
}

export default memo(HomeScreen);
